import './editable.scss';

function prepareFooterLink(link, positionClass = '') {
  if (!link) return;

  link.classList.add('rebredg-footer-link');

  if (positionClass) {
    link.classList.add(positionClass);
  }

  link.dataset.lineHover = '';
  link.dataset.circleFrom = 'top';
}

/**
 * Normalize native Gutenberg footer blocks back to the frontend classes used
 * by the existing layout and animation system. The links stay fully editable
 * in the Site Editor; this only adapts the rendered markup on the frontend.
 */
export function footerEditable(root = document) {
  const footer = root.querySelector('[data-site-footer]');
  if (!footer || footer.dataset.rebredgFooterEditableReady === 'true') return;

  footer.dataset.rebredgFooterEditableReady = 'true';

  const primaryNavigation = footer.querySelector('.rebredg-footer-primary-links');

  primaryNavigation?.querySelectorAll('.wp-block-navigation-item').forEach((item) => {
    const link = item.querySelector(':scope > a[href]');
    const positionClass = [...item.classList].find((className) =>
      className.startsWith('rebredg-footer-link--')
    );

    prepareFooterLink(link, positionClass || '');
  });

  const contactLink = footer.querySelector('.rebredg-footer-contact-nav .wp-block-navigation-item__content');
  prepareFooterLink(contactLink);
  contactLink?.classList.add('rebredg-footer-contact');

  footer.querySelectorAll('.rebredg-footer-socials .wp-block-social-link').forEach((item) => {
    const link = item.querySelector(':scope > a[href]');
    if (!link) return;

    link.classList.add('rebredg-footer-social');

    const serviceClass = [...item.classList].find((className) =>
      className.startsWith('wp-social-link-') && className !== 'wp-social-link'
    );

    if (serviceClass) {
      link.classList.add(`rebredg-footer-social--${serviceClass.replace('wp-social-link-', '')}`);
    }
  });
}
